import { createAction, props } from "@ngrx/store";
import { InvoiceDto } from "../interfaces/invoice_dto";
import { InvoiceItemDto } from "../interfaces/invoice_item_dto";
import { InvoiceAddRequest } from "../interfaces/invoice_add_request";
import { SendRequest } from "../interfaces/send_request";
import { InvoiceStatusDto } from "../interfaces/invoice_status_dto";

export const loadInvoices = createAction(
    "[Invoices] Load Invoices"
);

export const loadInvoicesSuccess = createAction(
    "[Invoices] Load Invoices Success",
    props<{ invoices: InvoiceDto[] }>()
);

export const upsertInvoices = createAction(
    "[Invoices] Upsert Invoices",
    props<{ invoices: InvoiceDto[] }>()
)

export const deleteInvoice = createAction(
    "[Invoices] Delete Invoice",
    props<{ invoiceId: number }>()
);

export const deleteInvoiceSuccess = createAction(
    "[Invoices] Delete Invoice Success",
    props<{ invoiceId: number }>()
);

export const selectInvoice = createAction(
    "[Invoices] Select Invoice",
    props<{ invoice: InvoiceDto }>()
);

export const getOpenInvoiceItems = createAction(
    "[Invoices] Get Open Invoice Items",
    props<{ student_id: number }>()
);

export const getOpenInvoiceItemsSuccess = createAction(
    "[Invoices] Get Open Invoice Items Success",
    props<{ invoiceItems: InvoiceItemDto[] }>()
);

export const removeOpenInvoiceItem = createAction(
    "[Invoices] Remove Open Invoice Item",
    props<{ invoiceItem: InvoiceItemDto }>()
);

export const addOrEditOpenInvoiceItem = createAction(
    "[Invoices] Add Open Invoice Item",
    props<{ invoiceItem: InvoiceItemDto }>()
);

export const clearOpenInvoiceItems = createAction(
    "[Invoices] Clear Open Invoice Items"
);

export const addInvoice = createAction(
    "[Invoices] Add Invoice",
    props<{ invoice: InvoiceAddRequest, status?: string, file: File }>()
);

export const addInvoiceSuccess = createAction(
    "[Invoices] Add Invoice Success",
    props<{ invoice: InvoiceDto }>()
);

export const downloadPdf = createAction(
    "[Invoices] Download Pdf",
    props<{ pdf: string, fileName: string }>()
);

export const downloadPdfSuccess = createAction(
    "[Invoices] Download Invoice Success"
);

export const downloadPdfFailure = createAction(
    "[Invoices] Download Invoice Failure"
);

export const createAndSendInvoiceMail = createAction(
    "[Invoices] Create And Send Invoice Mail",
    props<{ sendRequest: SendRequest, invoiceAddRequest: InvoiceAddRequest, file: File, payOnline: boolean }>()
);

export const sendMail = createAction(
    "[Invoices] Send Invoice Mail",
    props<{ sendRequest: SendRequest, payOnline: boolean }>()
);

export const sendMailSuccess = createAction(
    "[Invoices] Send Invoice Mail Success"
);

export const setVisible = createAction(
    "[Invoices] Set Visible",
    props<{ isVisible: boolean }>()
);

export const setInvoiceFilter = createAction(
    "[Invoices] Set Filter",
    props<{ invoiceFilter: string }>()
);

export const addInvoiceStatus = createAction(
    "[Invoices] Add Invoice Status",
    props<{ invoiceId: number, status: string }>()
)

export const addInvoiceStatusSuccess = createAction(
    "[Invoices] Add Invoice Status Success",
    props<{ status: InvoiceStatusDto }>()
)
